import React from 'react'
import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
	content: {
		fontFamily: 'raleway',
		fontSize:'36px',
		fontWeight:'300',
		display:'inline-block'
	}
}))


function SectionContentHeader(props) {
	const classes = useStyles()
	return (
		<div className={classes.content}>
			{props.text}
		</div>
	)
}

export default SectionContentHeader